import Axios from "./axios";

const resource = "resellers";

export default {
  getDetailsViaSlug(slug) {
		return Axios.get(`${resource}/slug/${slug}`);
	}
}